import { useLocation } from 'react-router-dom';

export type EditorSubPath = 'flow' | 'screens' | 'actions' | 'config' | 'theme';

const isEditorSubPath = (subpath: string) => {
  return ['flow', 'screens', 'actions', 'config', 'theme'].includes(subpath);
};

/**
 * @name `useEditorSubPath`
 *
 * A hook that returns the router sub-path to the specified editor (flow, screens, actions, config, theme)
 * or the editor base path (/dashboard/inquiry-templates/itmpl/itmplv/) based on provided params
 */
export default ({
  editorSubPath,
  onlyBasePath = false,
}: {
  editorSubPath: EditorSubPath;
  onlyBasePath?: boolean;
}): string => {
  const { pathname } = useLocation();
  const subPaths = pathname.split('/');
  const subPathIndex = subPaths.findIndex((subPath) =>
    onlyBasePath ? isEditorSubPath(subPath) : subPath === editorSubPath,
  );
  return subPaths.slice(0, onlyBasePath ? subPathIndex : subPathIndex + 1).join('/');
};
